import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { Filter, Main } from 'Containers';
import {
  AssignEntitiesEnum,
  BidGroupEnum,
  ItemEnum,
  SiteEnum,
  SiteGroupEnum,
} from 'Common/FieldEnum';
import { createToast, errorToast, toastType } from 'Common/ToastHelper';
import { DirtyWrapper, LoadingPage, NotificationDialog } from 'Components';
import { ASSIGN_ENTITIES_FORM_NAME } from 'Common/FormEnum';
import { resetForm, submitForm } from 'State/forms/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { DefaultTableState } from 'Common/Constants/table';
import {
  clearFilterErrorMsg,
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getStorageLocationForCurrentSite,
  getVendorForCurrentSite,
} from 'State/filters/actions';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { resetDirty } from 'State/dirtyTracking/actions';
import * as FilterSelectors from 'State/filters/selectors';

import {
  clearSubmitError,
  getItemsBySiteGroupId,
  getItemsBySiteId,
  getSiteGroupByItemId,
  getSiteGroupsByUserName,
  getSitesByItemId,
  getSitesByUserName,
  getUsersBySiteGroupId,
  getUsersBySiteId,
  resetAssignEntitiesPage,
  saveAssignEntities,
  setSiteGridInfo,
} from '../state/assignEntities/actions';
import {
  AssignEntitiesUserGridEnum,
  BASE_URL,
  callApiBasedOnRenderComponent,
  ComponentMapping,
  DropdownOptions,
  getCheckedData,
  getComponentOnSelection,
  getFilteredIds,
  getGridInitialValues,
  getPayload,
  GridNames,
  GridResetInitialValueEnum,
  INITIAL_VALUES,
  minMaxValidation,
} from '../helper/assignEntities';
import { AssignEntitiesContainer } from './containers/assignEntities/AssignEntities';
import * as Selectors from '../state/assignEntities/selectors';

class AssignEntities extends Component {
  static propTypes = {
    allItemsData: PropTypes.array.isRequired,
    sitesByItemId: PropTypes.array.isRequired,
    itemsBySiteId: PropTypes.array.isRequired,
    siteGroupsByItemId: PropTypes.array.isRequired,
    itemsBySiteGroupId: PropTypes.array.isRequired,
    sitesByUserName: PropTypes.array.isRequired,
    siteGroupsByUserName: PropTypes.array.isRequired,
    usersBySiteGroupId: PropTypes.array.isRequired,
    usersBySiteId: PropTypes.array.isRequired,
    saveAssignEntities: PropTypes.func.isRequired,
    clearSubmitError: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    resetAssignEntitiesPage: PropTypes.func.isRequired,
    setSiteGridInfo: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getAcctCategoryForCurrentSite: PropTypes.func.isRequired,
    getVendorForCurrentSite: PropTypes.func.isRequired,
    getStorageLocationForCurrentSite: PropTypes.func.isRequired,
    clearFilterErrorMsg: PropTypes.func.isRequired,
    getItemsBySiteId: PropTypes.func.isRequired,
    getItemsBySiteGroupId: PropTypes.func.isRequired,
    getSitesByUserName: PropTypes.func.isRequired,
    getSiteGroupsByUserName: PropTypes.func.isRequired,
    getUsersBySiteId: PropTypes.func.isRequired,
    getUsersBySiteGroupId: PropTypes.func.isRequired,
    getSitesByItemId: PropTypes.func.isRequired,
    getSiteGroupByItemId: PropTypes.func.isRequired,
    clearTableSavedState: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
    ItemGridInfo: PropTypes.array,
    SiteGroupGridInfo: PropTypes.array,
    SiteGridInfo: PropTypes.array,
    UserGridInfo: PropTypes.array,
    submitError: PropTypes.array,
    acctCategoryDataError: PropTypes.array,
    bidGroupDataError: PropTypes.array,
    itemGroupDataError: PropTypes.array,
    vendorDataError: PropTypes.array,
    storageLocationDataError: PropTypes.array,
    allTableStates: PropTypes.object.isRequired,
    submitSuccessMsg: PropTypes.string.isRequired,
    sortOptionsValue: PropTypes.string,
    dropDownValue: PropTypes.string,
    isSubmitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    fetchingDropdown: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    ItemGridInfo: [],
    SiteGroupGridInfo: [],
    SiteGridInfo: [],
    UserGridInfo: [],
    acctCategoryDataError: null,
    bidGroupDataError: null,
    itemGroupDataError: null,
    vendorDataError: null,
    storageLocationDataError: null,
    sortOptionsValue: AssignEntitiesEnum.Site,
    dropDownValue: AssignEntitiesEnum.FoodItems,
  };

  static path = BASE_URL;
  rightSideGridReactTableRef = React.createRef();

  state = {
    resetGridPage: {
      ...GridResetInitialValueEnum,
      [GridNames.Item]: false,
    },
    direction: true,
    isReadOnly: true,
    showMinMaxModal: false,
    isRightGridFiltered: false,
  };
  siteGridInstance = null;
  itemGridInstance = null;

  changeDirection = () => {
    this.setState({ direction: !this.state.direction });
  };

  handleMinMaxDialog = () => {
    this.setState({
      showMinMaxModal: false,
    });
  };

  setIsReadOnlyState = isReadOnly => {
    this.setState({
      isReadOnly: isReadOnly,
    });
  };

  onStorageLocationClick = () => {
    this.props.history.push(`${BASE_URL}/assignstoragelocation`);
  };

  getMainProps = showDirtyConfirm => {
    const { isSubmitting } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Assign Storage Location',
            onClick: this.onStorageLocationClick,
          },
          {
            content: 'Save',
            onClick: this.onSaveClick,
            disabled: isSubmitting,
            loading: isSubmitting,
          },
          {
            content: 'Cancel',
            onClick: showDirtyConfirm,
          },
        ],
        shown: true,
      },
    };
  };

  handleSubmit = values => {
    const {
      SortOptions,
      To,
      SiteGridInfo,
      ItemGridInfo,
      SiteGroupGridInfo,
    } = values;
    const renderedComponent = getComponentOnSelection(
      SortOptions,
      To,
      this.state.direction
    );
    const isMinMaxInvalid = minMaxValidation(
      SiteGridInfo,
      SiteGroupGridInfo,
      ItemGridInfo,
      renderedComponent
    );
    if (isMinMaxInvalid) {
      this.setState({
        showMinMaxModal: true,
      });
      return;
    }
    let payload;
    if (
      this.rightSideGridReactTableRef &&
      this.rightSideGridReactTableRef.current
    ) {
      const sortedData = this.rightSideGridReactTableRef.current.getResolvedState()
        .sortedData;

      switch (renderedComponent) {
        case ComponentMapping.SiteToItemsComponents:
        case ComponentMapping.SiteGroupToItemsComponents:
          let itemGridInitialValues = [];
          if (renderedComponent === ComponentMapping.SiteToItemsComponents) {
            itemGridInitialValues = this.props.itemsBySiteId;
          } else if (
            renderedComponent === ComponentMapping.SiteGroupToItemsComponents
          ) {
            itemGridInitialValues = this.props.itemsBySiteGroupId;
          }
          let itemGridInitialValuesCopy = _.cloneDeep(itemGridInitialValues);
          const sortedDataCopy = sortedData.map(item => {
            return item._original;
          });
          _.remove(itemGridInitialValuesCopy, item => {
            return sortedDataCopy.some(itemCopy => {
              return itemCopy.ItemCode === item.ItemCode && !item.Checkbox;
            });
          });
          let itemsToChange = _.unionBy(
            getCheckedData(sortedDataCopy, ItemEnum.CheckBox),
            itemGridInitialValuesCopy,
            ItemEnum.ItemCode
          );
          const itemValues = {
            ItemGridInfo: itemsToChange,
            SiteGridInfo: values[AssignEntitiesEnum.SiteGridInfo],
            SiteGroupGridInfo: values[AssignEntitiesEnum.SiteGroupGridInfo],
          };
          payload = getPayload(itemValues, renderedComponent);
          break;

        case ComponentMapping.SiteGroupToUsersComponents:
        case ComponentMapping.SiteToUsersComponents:
          let userGridInitialValues = [];
          if (renderedComponent === ComponentMapping.SiteToUsersComponents) {
            userGridInitialValues = this.props.usersBySiteId;
          } else if (
            renderedComponent === ComponentMapping.SiteGroupToUsersComponents
          ) {
            userGridInitialValues = this.props.usersBySiteGroupId;
          }
          let userGridInitialValuesCopy = [...userGridInitialValues];
          const userSortedDataCopy = getFilteredIds(
            sortedData,
            AssignEntitiesUserGridEnum.UserName
          );
          const gridUsers = _.intersection(
            userSortedDataCopy,
            values.UserGridInfo
          );
          //remove un-checked values
          _.remove(userGridInitialValuesCopy, userName => {
            return userSortedDataCopy.indexOf(userName) > -1;
          });
          const usersToChange = _.union(gridUsers, userGridInitialValuesCopy);
          const userValues = {
            UserGridInfo: usersToChange,
            SiteGridInfo: values[AssignEntitiesEnum.SiteGridInfo],
            SiteGroupGridInfo: values[AssignEntitiesEnum.SiteGroupGridInfo],
          };
          payload = getPayload(userValues, renderedComponent);
          break;

        case ComponentMapping.ItemToSitesComponents:
          let siteGridInitialValuesCopy = _.cloneDeep(this.props.sitesByItemId);
          const sortedSiteDataCopy = sortedData.map(site => {
            return site._original;
          });
          _.remove(siteGridInitialValuesCopy, site => {
            return sortedSiteDataCopy.some(siteCopy => {
              return siteCopy.Id === site.Id && !site.Checkbox;
            });
          });
          let sitesToChange = _.unionBy(
            getCheckedData(sortedSiteDataCopy, SiteEnum.CheckBox),
            siteGridInitialValuesCopy,
            SiteEnum.Id
          );

          const sitesValues = {
            ItemGridInfo: values[AssignEntitiesEnum.ItemGridInfo],
            SiteGridInfo: sitesToChange,
          };
          payload = getPayload(sitesValues, renderedComponent);
          break;

        case ComponentMapping.UserToSitesComponents:
          let sitesByUserNameCopy = [...this.props.sitesByUserName];
          const siteSortedDataCopy = getFilteredIds(sortedData, SiteEnum.Id);
          const gridSites = _.intersection(
            siteSortedDataCopy,
            values.SiteGridInfo
          );
          //remove un-checked values
          _.remove(sitesByUserNameCopy, site => {
            return siteSortedDataCopy.indexOf(site) > -1;
          });
          const siteIdsToChange = _.union(gridSites, sitesByUserNameCopy);
          const siteIds = {
            UserGridInfo: values[AssignEntitiesEnum.UserGridInfo],
            SiteGridInfo: siteIdsToChange,
          };
          payload = getPayload(siteIds, renderedComponent);
          break;

        case ComponentMapping.UserToSiteGroupsComponents:
          let siteGroupsByUserNameCopy = [...this.props.siteGroupsByUserName];
          const siteGroupSortedDataCopy = getFilteredIds(
            sortedData,
            SiteEnum.Id
          );
          const gridSiteGroups = _.intersection(
            siteGroupSortedDataCopy,
            values.SiteGroupGridInfo
          );
          //remove un-checked values
          _.remove(siteGroupsByUserNameCopy, userName => {
            return siteGroupSortedDataCopy.indexOf(userName) > -1;
          });
          const siteGroupIdsToChange = _.union(
            gridSiteGroups,
            siteGroupsByUserNameCopy
          );
          const siteGroupIds = {
            UserGridInfo: values[AssignEntitiesEnum.UserGridInfo],
            SiteGroupGridInfo: siteGroupIdsToChange,
          };
          payload = getPayload(siteGroupIds, renderedComponent);
          break;

        case ComponentMapping.ItemToSiteGroupsComponents:
          let siteGroupsByItemIdCopy = _.cloneDeep(
            this.props.siteGroupsByItemId
          );
          const sortedSiteGroupDataCopy = sortedData.map(siteGroup => {
            return siteGroup._original;
          });
          _.remove(siteGroupsByItemIdCopy, siteGroup => {
            return sortedSiteGroupDataCopy.some(siteGroupCopy => {
              return siteGroupCopy.Id === siteGroup.Id && !siteGroup.Checkbox;
            });
          });
          let siteGroupsToChange = _.unionBy(
            getCheckedData(sortedSiteGroupDataCopy, SiteGroupEnum.CheckBox),
            siteGroupsByItemIdCopy,
            SiteGroupEnum.Id
          );

          const siteGroupsValues = {
            ItemGridInfo: values[AssignEntitiesEnum.ItemGridInfo],
            SiteGroupGridInfo: siteGroupsToChange,
          };
          payload = getPayload(siteGroupsValues, renderedComponent);
          break;

        default:
          payload = void 0;
      } // end of switch case
    } else {
      payload = getPayload(values, renderedComponent);
    }

    if (payload) {
      this.setState({
        isReadOnly: true,
      });
      this.props.saveAssignEntities(payload, renderedComponent).then(() => {
        callApiBasedOnRenderComponent(
          this.props,
          renderedComponent,
          this.onResetPageOnDataChange
        );
      });
    }
  };

  onResetPageOnDataChange = resetGridPage => {
    resetGridPage && this.setState({ resetGridPage });
  };

  onFilteredChange = filtered => {
    this.setState({
      isRightGridFiltered: Boolean(filtered && filtered.length),
    });
  };

  componentWillUnmount() {
    const { allTableStates, setTableStates } = this.props;
    this.props.resetForm(ASSIGN_ENTITIES_FORM_NAME);
    this.clearTableSavedState();
    toast.dismiss();
    // using setTableState as state change render is fired, so instance refresh won't work
    setTableStates({
      ...allTableStates,
      [TableNamesEnum.ASSIGN_ENTITIES_ITEM_GRID_TABLE]: DefaultTableState,
      [TableNamesEnum.ASSIGN_ENTITIES_SITE_GRID_TABLE]: DefaultTableState,
      [TableNamesEnum.ASSIGN_ENTITIES_USER_GRID_TABLE]: DefaultTableState,
    });
  }

  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, BASE_URL, allTableStates, setTableStates, [
      TableNamesEnum.ASSIGN_ENTITIES_ITEM_GRID_TABLE,
      TableNamesEnum.ASSIGN_ENTITIES_SITE_GRID_TABLE,
      TableNamesEnum.ASSIGN_ENTITIES_USER_GRID_TABLE,
    ]);
  };

  onSaveClick = () => {
    this.props.submitForm(ASSIGN_ENTITIES_FORM_NAME);
  };

  onCancelClick = () => {
    this.setState({
      isReadOnly: true,
    });
    const { resetDirty, sortOptionsValue, dropDownValue } = this.props;
    const renderedComponent = getComponentOnSelection(
      sortOptionsValue,
      dropDownValue,
      this.state.direction
    );

    const allFormValues = {
      [AssignEntitiesEnum.ItemGridInfo]: this.props[
        AssignEntitiesEnum.ItemGridInfo
      ],
      [AssignEntitiesEnum.SiteGridInfo]: this.props[
        AssignEntitiesEnum.SiteGridInfo
      ],
      [AssignEntitiesEnum.SiteGroupGridInfo]: this.props[
        AssignEntitiesEnum.SiteGroupGridInfo
      ],
      [AssignEntitiesEnum.UserGridInfo]: this.props[
        AssignEntitiesEnum.UserGridInfo
      ],
    };
    const reducerInitialValues = {
      sitesByItemId: this.props.sitesByItemId,
      itemsBySiteId: this.props.itemsBySiteId,
      siteGroupsByItemId: this.props.siteGroupsByItemId,
      itemsBySiteGroupId: this.props.itemsBySiteGroupId,
      sitesByUserName: this.props.sitesByUserName,
      siteGroupsByUserName: this.props.siteGroupsByUserName,
      usersBySiteGroupId: this.props.usersBySiteGroupId,
      usersBySiteId: this.props.usersBySiteId,
    };
    const gridInitialValues = getGridInitialValues(
      renderedComponent,
      allFormValues,
      reducerInitialValues
    );
    const { leftGridData, rightGridData } = gridInitialValues;
    if (!leftGridData || !rightGridData) {
      return;
    }
    this.props.resetAssignEntitiesPage(leftGridData, rightGridData);
    resetDirty();
  };

  componentDidMount() {
    const {
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getAcctCategoryForCurrentSite,
      getVendorForCurrentSite,
      getStorageLocationForCurrentSite,
    } = this.props;
    getBidGroupForCurrentSite(BidGroupEnum.UnassignedAndAll);
    getItemGroupForCurrentSite();
    getAcctCategoryForCurrentSite();
    getVendorForCurrentSite();
    getStorageLocationForCurrentSite();
  }

  componentDidUpdate(prevProps) {
    const { clearSubmitError, submitSuccessMsg } = this.props;
    if (
      errorToast(this.props, prevProps, 'submitError') ||
      errorToast(this.props, prevProps, 'acctCategoryDataError') ||
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'vendorDataError') ||
      errorToast(this.props, prevProps, 'storageLocationDataError')
    ) {
      clearSubmitError();
      clearFilterErrorMsg();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(toastType.success, 'Success', submitSuccessMsg, true);
      clearFilterErrorMsg();
      clearSubmitError();
    }
  }

  clearFilter = () => {
    const SiteGridInfoCopy = [...this.props.SiteGridInfo];
    this.props.resetForm(ASSIGN_ENTITIES_FORM_NAME);
    this.props.setSiteGridInfo(SiteGridInfoCopy);
    this.setState({ direction: true });
    const { siteGridInstance, itemGridInstance } = this;
    // using instance for site to item map
    siteGridInstance && siteGridInstance.clearTableState();
    itemGridInstance && itemGridInstance.clearTableState();
    // using setTableState as state change render is fired, so instance refresh won't work
    const { allTableStates, setTableStates } = this.props;
    setTableStates({
      ...allTableStates,
      [TableNamesEnum.ASSIGN_ENTITIES_ITEM_GRID_TABLE]: DefaultTableState,
      [TableNamesEnum.ASSIGN_ENTITIES_SITE_GRID_TABLE]: DefaultTableState,
      [TableNamesEnum.ASSIGN_ENTITIES_USER_GRID_TABLE]: DefaultTableState,
    });
  };

  setSiteGridInstance = ref => {
    this.siteGridInstance = ref;
  };

  setItemGridInstance = ref => {
    this.itemGridInstance = ref;
  };

  render() {
    const {
      isReadOnly,
      direction,
      resetGridPage,
      isRightGridFiltered,
      showMinMaxModal,
    } = this.state;
    const { fetchingDropdown, dropDownValue } = this.props;

    return fetchingDropdown ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter
          title={dropDownValue === DropdownOptions[0].value
              ? 'Items Access'
              : 'Users Access'}
          style={{
            width: 400,
          }}
        />
        <DirtyWrapper
          closeModalYesCallback={this.onCancelClick}
          isReadOnly={isReadOnly}
        >
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              <AssignEntitiesContainer
                initialValues={{ ...INITIAL_VALUES }}
                direction={direction}
                changeDirection={this.changeDirection}
                onSubmit={this.handleSubmit}
                clearFilter={this.clearFilter}
                setIsReadOnlyState={this.setIsReadOnlyState}
                isReadOnly={isReadOnly}
                setSiteGridInstance={this.setSiteGridInstance}
                setItemGridInstance={this.setItemGridInstance}
                siteGridInstance={this.siteGridInstance}
                itemGridInstance={this.itemGridInstance}
                rightSideGridReactTableRef={this.rightSideGridReactTableRef}
                resetGridPage={resetGridPage}
                onResetPageOnDataChange={this.onResetPageOnDataChange}
                onFilteredChange={this.onFilteredChange}
                isRightGridFiltered={isRightGridFiltered}
              />
            </Main>
          )}
        </DirtyWrapper>
        <NotificationDialog
          title={'Inventory'}
          showDialog={showMinMaxModal}
          message={'Max Par must be greater than Min Par.'}
          onOkClick={this.handleMinMaxDialog}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(ASSIGN_ENTITIES_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(ASSIGN_ENTITIES_FORM_NAME)(state));

  return {
    ItemGridInfo: selector(state, AssignEntitiesEnum.ItemGridInfo),
    SiteGroupGridInfo: selector(state, AssignEntitiesEnum.SiteGroupGridInfo),
    SiteGridInfo: selector(state, AssignEntitiesEnum.SiteGridInfo),
    UserGridInfo: selector(state, AssignEntitiesEnum.UserGridInfo),
    sortOptionsValue: selector(state, AssignEntitiesEnum.SortOptions),
    dropDownValue: selector(state, AssignEntitiesEnum.To),
    allTableStates: getTableStates(state),

    fetchingDropdown:
      FilterSelectors.getBidGroupDataLoading(state) ||
      FilterSelectors.getItemGroupDataLoading(state) ||
      FilterSelectors.getAcctCategoryDataLoading(state) ||
      FilterSelectors.getVendorDataLoading(state) ||
      FilterSelectors.getStorageLocationDataLoading(state),

    acctCategoryDataError: FilterSelectors.getAcctCategoryDataError(state),
    bidGroupDataError: FilterSelectors.getBidGroupDataError(state),
    itemGroupDataError: FilterSelectors.getItemGroupDataError(state),
    vendorDataError: FilterSelectors.getVendorDataError(state),
    storageLocationDataError: FilterSelectors.getStorageLocationDataError(
      state
    ),

    isSubmitting: Selectors.getIsSubmitting(state),
    submitted: Selectors.getSubmitted(state),
    submitError: Selectors.getSubmitError(state),
    submitSuccessMsg: Selectors.getSubmitSuccessMsg(state),
    allItemsData: Selectors.getAllItemsData(state),
    sitesByItemId: Selectors.getSitesByItemId(state),
    itemsBySiteId: Selectors.getItemsBySiteId(state),
    siteGroupsByItemId: Selectors.getSiteGroupsByItemId(state),
    itemsBySiteGroupId: Selectors.getItemsBySiteGroupId(state),
    sitesByUserName: Selectors.getSitesByUserName(state),
    siteGroupsByUserName: Selectors.getSiteGroupsByUserName(state),
    usersBySiteGroupId: Selectors.getUsersBySiteGroupId(state),
    usersBySiteId: Selectors.getUsersBySiteId(state),
  };
};

const mapDispatchToProps = {
  saveAssignEntities,
  clearSubmitError,
  submitForm,
  resetForm,
  resetAssignEntitiesPage,
  setSiteGridInfo,
  setTableStates,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getAcctCategoryForCurrentSite,
  getVendorForCurrentSite,
  getStorageLocationForCurrentSite,
  clearFilterErrorMsg,
  getItemsBySiteId,
  getItemsBySiteGroupId,
  getSitesByUserName,
  getSiteGroupsByUserName,
  getUsersBySiteId,
  getUsersBySiteGroupId,
  getSitesByItemId,
  getSiteGroupByItemId,
  clearTableSavedState,
  resetDirty,
};

export const AssignEntitiesMainContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignEntities);



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/AssignEntitiesContainer.js